module.exports = __webpack_public_path__ + "static/media/product-health.42e53773.svg";